<template>
    <v-sheet class="ma-4">
        <h1>Retningslinjer for informasjonskapsler for Visuado.com</h1>
        <br />
        <p>
            Slik det er vanlig praksis med nesten alle profesjonelle nettsteder, bruker dette
            nettstedet informasjonskapsler (cookies), som er små filer som lastes ned til
            datamaskinen for å forbedre opplevelsen din. Denne siden beskriver hvilken informasjon
            de samler inn, hvordan vi bruker den, og hvorfor vi noen ganger har behov for å lagre
            disse informasjonskapslene. Vi vil også beskrive hvordan du kan forhindre at disse
            informasjonskapslene lagres, men vær oppmerksom på at dette kan redusere eller
            "ødelegge" visse elementer I nettstedets funksjonalitet.
        </p>
        <p>
            For mer generell informasjon om informasjonskapsler kan du lese
            <a href="https://en.wikipedia.org/wiki/HTTP_cookie" target="_blank"
                >wikipedia-artikkelen om http informasjonskapsler</a
            >.
        </p>

        <h2>Hvordan bruker vi informasjonskaspler</h2>

        <p>
            Vi bruker informasjonskapsler av en rekke årsaker som er beskrevet nedenfor. Dessverre
            er det I de fleste tilfeller ingen industristandard for å deaktivere informasjonskapsler
            uten helt å deaktivere funksjonalitet og funksjoner som de tilfører nettstedet. Det
            anbefales at du lar alle informasjonskapsler være som de er hvis du ikke er sikker på om
            du trenger dem eller ikke, I tilfelle de brukes til å levere en tjeneste du bruker.
        </p>

        <h2>Deaktivere informasjonskapsler</h2>

        <p>
            Du kan forhindre lagring av informasjonskapsler ved å justere innstillingene for
            nettleseren din (se hjelp for nettleserens om hvordan du gjør dette). Vær oppmerksom på
            at deaktivering av informasjonskapsler vil påvirke funksjonaliteten til dette og mange
            andre nettsteder du besøker. Deaktivering av informasjonskapsler vil vanligvis også føre
            til deaktivering av enkelte funksjoner på dette nettstedet. Derfor anbefales det at du
            ikke deaktiverer informasjonskapsler.
        </p>

        <h2>Informasjonskapsler vi lagrer</h2>

        <p>
            Hvis du oppretter en konto hos oss, bruker vi informasjonskapsler for administrasjon av
            registreringsprosessen og generell administrasjon. Disse informasjonskapslene vil
            vanligvis bli slettet når du logger ut, men I noen tilfeller kan de bli værende igjen
            for å huske innstillinger for nettsteder når du er logget ut.
        </p>

        <p>
            Vi bruker informasjonskapsler når du er logget inn, slik at vi kan huske dette. Dette
            hindrer deg I å måtte logge inn hver eneste gang du besøker en ny side. Disse
            informasjonskapslene blir vanligvis fjernet eller slettet når du logger deg ut for å
            sikre at du bare kan få tilgang til begrensede funksjoner og områder når du er logget
            inn.
        </p>

        <p>
            Dette nettstedet tilbyr nyhetsbrev eller abonnementstjenester via e-post, og
            informasjonskapsler kan brukes til å huske om du allerede er registrert, og om du vil
            vise visse meldinger som gjelder bare for abonnerende / ikke-abonnerende brukere.
        </p>

        <p>
            Fra tid til annen kan vi tilby brukerundersøkelser og spørreskjemaer for å formidle
            spennende kunnskap og gi deg nyttige verktøy, eller for å forstå brukerbasen vår bedre.
            Disse undersøkelsene kan bruke informasjonskapsler til å huske hvem som allerede har
            deltatt I en undersøkelse, eller gi deg nøyaktige resultater etter at du bytter sider.
        </p>

        <p>
            Når du sender inn data gjennom et skjema slik som de som finnes på kontaktsider eller
            kommentarskjemaer, kan informasjonskapsler angis til å huske dine brukeropplysninger ved
            fremtidig korrespondanse.
        </p>

        <p>
            For å gi deg en best mulig opplevelse på dette området tilbyr vi funksjonalitet for å
            angi innstillinger om hvordan dette nettstedet kjøres når du bruker det. For å huske
            dine preferanser må vi angi informasjonskapsler slik at informasjonen kan hentes opp når
            du er inne på en side som påvirkes av dine preferanser.
        </p>

        <h2>Informasjonskapsler fra tredjepart.</h2>

        <p>
            I noen spesielle tilfeller bruker vi også informasjonskapsler fra klarerte tredjeparter.
            Følgende avsnitt beskriver hvilke informasjonskapsler fra tredjepart du kan støte på via
            dette nettstedet.
        </p>

        <p>
            For mer informasjon om google analytics informasjonskapsler, se den offisielle side for
            google analytics.
        </p>

        <p>
            Tredjepartsanalyser brukes til å spore og måle bruken av dette området, slik at vi kan
            fortsette å produsere engasjerende innhold. Disse informasjonskapslene kan holde orden
            på blant annet hvor lang tid du bruker på nettstedet eller hvilke sider du besøker, noe
            som hjelper oss å forstå hvordan vi kan forbedre nettstedet for deg.
        </p>

        <p>
            Fra tid til annen tester vi ut nye funksjoner og foretar små endringer I måten
            nettstedet leveres på. Når vi fortsatt tester nye funksjoner, kan disse
            informasjonskapslene brukes til å sikre at du får en ensartet opplevelse mens du er på
            nettstedet samtidig som vi er sikre på at vi forstår hvilke optimaliseringer våre
            brukere setter mest pris på.
        </p>

        <p>
            Vi bruker også knapper for og/eller plugins for sosiale medier på dette nettstedet, noe
            som gjør at du kan koble deg til ditt sosiale nettverk på ulike måter. For at disse skal
            virke vil følgende nettsteder for sosiale medier, inkludert facebook, linkedin og
            youtube lagre informasjonskapsler gjennom vårt nettsted, og disse kan brukes til å
            forbedre profilen din på deres nettsted eller bidra til at dataene oppbevares til ulike
            formål som beskrevet I deres respektive retningslinjer for personvern.
        </p>

        <h2>Mer informasjon</h2>

        <p>
            Forhåpentligvis har dette avklart ting for deg, og som tidligere nevnt: hvis det er noe
            du er usikker på om du trenger eller ikke, er det vanligvis tryggere å la
            informasjonskapsler være aktivert I tilfelle de virker sammen med en av funksjonene du
            bruker på nettstedet vårt. Men hvis du fortsatt ønsker mer informasjon, kan du kontakte
            oss via en av våre foretrukne kontaktmetoder.
        </p>

        <p>
            <v-btn v-if="consent" outlined @click="$withdrawConsent">
                Trekk tilbake ditt samtykke</v-btn
            >
        </p>
    </v-sheet>
</template>
<script setup>
const { $withdrawConsent } = useNuxtApp()

const cookieConsent = useCookie('visuado-cookie-consent')
const consent = computed(() => {
    return cookieConsent.value === 'accepted'
})
</script>
